import { FormOperator } from 'shared/Form/types';

export const CONDITION_OPERATORS: IOption[] = [
  {
    value: FormOperator.FILLED,
    label: 'заполнено',
  },
  {
    value: FormOperator.EMPTY,
    label: 'пусто',
  },
  {
    value: FormOperator.EQUAL,
    label: 'равно',
  },
  {
    value: FormOperator.NOT_EQUAL,
    label: 'не равно',
  },
  {
    value: FormOperator.TEST,
    label: 'выражение',
  },
];
